import { SkeletonChild, SkeletonParent } from '@/components/ui/Skeleton/skeleton';

export const GmBarDesktopSkeleton = () => {
  return (
    <SkeletonParent className="w-full h-[8.438rem] rounded-none p-4 flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <SkeletonChild className="size-11 shrink-0 rounded-full" />
        <SkeletonChild className="h-3.5 w-full rounded-full" />
        <SkeletonChild className="h-4 w-full max-w-[2.188rem] rounded-full" />
      </div>

      <div className="flex items-center flex-col gap-1">
        <div className="flex items-center w-full gap-2">
          <SkeletonChild className="size-[1.688rem] shrink-0 rounded-full" />
          <SkeletonChild className="w-full h-4 rounded-full" />
        </div>

        <div className="flex w-full justify-between gap-2">
          <SkeletonChild className="w-full h-4 rounded-full max-w-14" />
          <SkeletonChild className="w-full h-4 rounded-full max-w-13.5" />
        </div>
      </div>
    </SkeletonParent>
  );
};
